  
import * as React from 'react'

import { ReactComponent as ExpandEditor } from '@/assets/icons/editor/expand-editor.svg'
import { ReactComponent as CrossTimes } from '@/assets/icons/editor/cross-times.svg'

import './styles.sass'

export default function HeaderSection (props) {
  const [canDelete, setCanDelete] = React.useState(!!props.draft?.id || false)

  // eslint-disable-next-line
  async function discardDraft () {
    setCanDelete(false)
    props.setShouldEditOnModal(false)
    await props.discardDraft()
  }

  return (
    <div className='message-modal-header'>
      <span className='message-modal-header-text'>
        Compose a new message
      </span>
      <div className='message-modal-header-actions'>
        <div className='option unactive'>
          { canDelete && <ExpandEditor/> }
        </div>
        <div className='option' onClick={props.onClose}>
          <CrossTimes />
        </div>
      </div>
    </div>
  )
}
